type toaParameters = Parameters<typeof btoa>;
type toaReturnType = ReturnType<typeof btoa>;

// string => base64 (支持中文)
const zhbtoa = (...[s]: toaParameters): toaReturnType => btoa(unescape(encodeURIComponent(s)));

type tobParameters = Parameters<typeof atob>;
type tobReturnType = ReturnType<typeof atob>;

// base64 => string (支持中文)
const zhatob = (...[b]: tobParameters): tobReturnType => decodeURIComponent(escape(atob(b)));

export {
  zhbtoa as btoa,
  zhatob as atob,
};
